import AdminSpectator from './admin-spectator';

export default AdminSpectator;
